module.exports = __webpack_public_path__ + "assets/b31cf82ec12cce92ec7873eb91b08a1e.mp3";